import React from 'react';
import { FaTrash, FaExclamationTriangle, FaQuestionCircle } from 'react-icons/fa';
import './ConfirmModal.css';

export default function ConfirmModal({
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel  = 'Cancel',
  variant      = 'danger', // 'danger' | 'warning' | 'neutral'
  onConfirm,
  onCancel,
}) {
  const Icon = variant === 'danger' ? FaTrash
             : variant === 'warning' ? FaExclamationTriangle
             : FaQuestionCircle;

  return (
    <div className="cm-overlay" onClick={onCancel}>
      <div className="cm-card" onClick={e => e.stopPropagation()}>
        <div className={`cm-icon-wrap ${variant}`}>
          <Icon />
        </div>
        <h3 className="cm-title">{title}</h3>
        {message && <p className="cm-message">{message}</p>}
        <div className="cm-actions">
          <button className="cm-btn cm-btn-cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            className={`cm-btn cm-btn-confirm-${variant}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
